import { render, staticRenderFns } from "./NoResultInfo.vue?vue&type=template&id=6993c6d2"
import script from "./noResultInfo.ts?vue&type=script&lang=ts&external"
export * from "./noResultInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports